import { FormControlLabel, Checkbox as MuiCheckbox } from "@mui/material";

import { useFieldContext } from "./form.context";

type Props = {
  label: string | React.ReactNode;
  disabled?: boolean;
};

export function CheckboxField({ label, disabled }: Props) {
  const field = useFieldContext<boolean>();
  const checked = field.state.value ?? false;

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          name={field.name}
          checked={checked}
          onChange={(e) => field.handleChange(e.target.checked)}
          onBlur={field.handleBlur}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
}
